const DEV_HOST = 'https://usuarios.trazo.dev'
let PROD_HOST = window.location.protocol + '//' + window.location.hostname

PROD_HOST = PROD_HOST.replace('cursos', 'usuarios')

export const isDev = process.env.NODE_ENV === 'development'

export const userAPIRoot = isDev ? `${DEV_HOST}` : `${PROD_HOST}`



// WEBPACK FOOTER //
// ./src/config/redirect.config.js